(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  
  const openClose = document.getElementById('open-close');
  const blockerBlock = document.getElementById('blocker-block');
  const openCloseMenuMob = document.getElementById('open-close-menu-mob');
  const details = document.getElementById('Details-menu-drawer-container');

  const openCloseMenu = () => {

    const body = document.body;
    const className = 'open-menu'
    
    if(body.classList.contains(className)){
       body.classList.remove(className);
    }else{
       body.classList.add(className);
    }
  }

  const changeToggle = () => {
    details.classList.toggle('open')
    openCloseMenu()
  }

  
  if (openClose) openClose.addEventListener("click", changeToggle, false);
  if (blockerBlock) blockerBlock.addEventListener("click", changeToggle, false);
  if (openCloseMenuMob) openCloseMenuMob.addEventListener("click", changeToggle, false);

  // Smooth Submenu Accordion Animation for Menu Drawer
  document.querySelectorAll('.menu-drawer details').forEach((detail) => {
    const summary = detail.querySelector('summary');
    const content = detail.querySelector('.menu-drawer__submenu');
    if (!summary || !content) return;

    let isAnimating = false;

    summary.addEventListener('click', (e) => {
      // Only apply accordion on mobile (< 990px)
      if (window.innerWidth >= 990) return;

      e.preventDefault();
      if (isAnimating) return;

      if (detail.open) {
        // Smooth Collapse
        isAnimating = true;
        const startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.28s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease';
        
        requestAnimationFrame(() => {
          content.style.height = '0px';
          content.style.opacity = '0';
        });

        setTimeout(() => {
          detail.removeAttribute('open');
          content.style.height = '';
          content.style.opacity = '';
          content.style.transition = '';
          content.style.overflow = '';
          isAnimating = false;
        }, 280);
      } else {
        // Smooth Expand
        isAnimating = true;

        // Collapse other open submenus smoothly
        document.querySelectorAll('.menu-drawer details[open]').forEach((other) => {
          if (other !== detail) {
            const otherContent = other.querySelector('.menu-drawer__submenu');
            if (otherContent) {
              otherContent.style.height = otherContent.scrollHeight + 'px';
              otherContent.style.overflow = 'hidden';
              otherContent.style.transition = 'height 0.25s ease, opacity 0.2s ease';
              requestAnimationFrame(() => {
                otherContent.style.height = '0px';
                otherContent.style.opacity = '0';
              });
              setTimeout(() => {
                other.removeAttribute('open');
                otherContent.style.height = '';
                otherContent.style.opacity = '';
                otherContent.style.transition = '';
                otherContent.style.overflow = '';
              }, 250);
            } else {
              other.removeAttribute('open');
            }
          }
        });

        detail.setAttribute('open', '');
        const targetHeight = content.scrollHeight;
        content.style.height = '0px';
        content.style.opacity = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.32s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease';

        requestAnimationFrame(() => {
          content.style.height = targetHeight + 'px';
          content.style.opacity = '1';
        });

        setTimeout(() => {
          content.style.height = '';
          content.style.opacity = '';
          content.style.transition = '';
          content.style.overflow = '';
          isAnimating = false;
        }, 320);
      }
    });
  });

  function handleDesktopOutsideAndScroll() {
    // 1. Outside click handling for submenus and sidebar
    document.addEventListener("click", (event) => {
      if (window.innerWidth >= 990) {
        // Close open details submenus if clicked outside the details element
        document.querySelectorAll("[id^='Details-menu-drawer-menu-item-']").forEach(element => {
          if (element.hasAttribute("open") && !element.contains(event.target)) {
            element.removeAttribute("open");
            if (element.parentElement) element.parentElement.style.zIndex = '';
          }
        });

        // Auto-collapse expanded sidebar if clicked completely outside drawer container
        const drawerContainer = document.getElementById('Details-menu-drawer-container');
        if (drawerContainer && drawerContainer.classList.contains('open') && !drawerContainer.contains(event.target)) {
          drawerContainer.classList.remove('open');
          document.body.classList.remove('open-menu');
        }
      }
    });

    // 2. Submenu toggle: ensure active item has top z-index and closes siblings
    document.querySelectorAll("[id^='Details-menu-drawer-menu-item-']").forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (window.innerWidth >= 990 && detail.open) {
          document.querySelectorAll("[id^='Details-menu-drawer-menu-item-'][open]").forEach(other => {
            if (other !== detail) {
              other.removeAttribute('open');
              if (other.parentElement) other.parentElement.style.zIndex = '';
            }
          });
          if (detail.parentElement) detail.parentElement.style.zIndex = '1000';
        } else if (!detail.open && detail.parentElement) {
          detail.parentElement.style.zIndex = '';
        }
      });
    });

    // 3. Dynamic height clamping above footer and auto-collapse on scroll
    let lastScrollY = window.scrollY;
    let isTicking = false;

    const clampSidebarHeight = () => {
      if (window.innerWidth < 990) return;
      const menuDrawer = document.getElementById('menu-drawer');
      if (!menuDrawer) return;

      const footer = document.querySelector('footer') || document.querySelector('.footer') || document.getElementById('shopify-section-footer');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const header = document.querySelector('.header-wrapper') || document.querySelector('header');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 64;

        if (footerRect.top < window.innerHeight) {
          const availableHeight = Math.max(0, footerRect.top - headerBottom);
          menuDrawer.style.setProperty('height', availableHeight + 'px', 'important');
        } else {
          menuDrawer.style.removeProperty('height');
        }
      }
    };

    window.addEventListener('scroll', () => {
      if (window.innerWidth < 990) return;
      const drawerContainer = document.getElementById('Details-menu-drawer-container');

      if (!isTicking) {
        window.requestAnimationFrame(() => {
          // Auto-collapse expanded sidebar on scroll
          if (drawerContainer && drawerContainer.classList.contains('open')) {
            const currentScrollY = window.scrollY;
            if (Math.abs(currentScrollY - lastScrollY) > 20) {
              drawerContainer.classList.remove('open');
              document.body.classList.remove('open-menu');
              document.querySelectorAll("[id^='Details-menu-drawer-menu-item-'][open]").forEach(element => {
                element.removeAttribute('open');
                if (element.parentElement) element.parentElement.style.zIndex = '';
              });
            }
            lastScrollY = currentScrollY;
          }

          // Dynamic height clamp above footer
          clampSidebarHeight();

          isTicking = false;
        });
        isTicking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        clampSidebarHeight();
      } else {
        const menuDrawer = document.getElementById('menu-drawer');
        if (menuDrawer) menuDrawer.style.removeProperty('height');
      }
    }, { passive: true });

    clampSidebarHeight();
  }

  handleDesktopOutsideAndScroll();

  // Desktop Global Search Expandable Bar
  const headerSearchToggle = document.getElementById('HeaderSearchToggle');
  const globalSearchBlock = document.getElementById('GlobalSearchBlock');
  const globalSearchBackdrop = document.getElementById('GlobalSearchBackdrop');
  const globalSearchInput = document.getElementById('GlobalSearchInput');
  const globalSearchClearBtn = document.getElementById('GlobalSearchClearBtn');
  const headerSearchIconImg = document.getElementById('HeaderSearchIconImg');
  const headerSearchCloseIcon = document.getElementById('HeaderSearchCloseIcon');

  function setGlobalSearchOpen(isOpen) {
    if (!globalSearchBlock) return;
    if (isOpen) {
      globalSearchBlock.style.display = 'block';
      setTimeout(() => {
        globalSearchBlock.classList.add('open');
        if (globalSearchInput) globalSearchInput.focus();
      }, 10);
      if (headerSearchIconImg) headerSearchIconImg.style.display = 'none';
      if (headerSearchCloseIcon) headerSearchCloseIcon.style.display = 'block';
    } else {
      globalSearchBlock.classList.remove('open');
      setTimeout(() => {
        if (!globalSearchBlock.classList.contains('open')) {
          globalSearchBlock.style.display = 'none';
        }
      }, 300);
      if (headerSearchIconImg) headerSearchIconImg.style.display = 'block';
      if (headerSearchCloseIcon) headerSearchCloseIcon.style.display = 'none';
    }
  }

  if (headerSearchToggle) {
    headerSearchToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = globalSearchBlock && globalSearchBlock.classList.contains('open');
      setGlobalSearchOpen(!isOpen);
    });
  }

  if (globalSearchBackdrop) {
    globalSearchBackdrop.addEventListener('click', () => {
      setGlobalSearchOpen(false);
    });
  }

  if (globalSearchClearBtn && globalSearchInput) {
    globalSearchClearBtn.addEventListener('click', () => {
      globalSearchInput.value = '';
      globalSearchInput.focus();
    });
  }

  // Floating Navigation Menu Button (Bottom Left)
  const floatingMenuBtn = document.getElementById('FloatingMenuBtn');
  const floatingMenuIcon = document.getElementById('FloatingMenuBtnMenuIcon');
  const floatingMenuClose = document.getElementById('FloatingMenuBtnCloseIcon');

  function updateFloatingMenuIcon(isOpen) {
    if (floatingMenuIcon && floatingMenuClose) {
      floatingMenuIcon.style.display = isOpen ? 'none' : 'block';
      floatingMenuClose.style.display = isOpen ? 'block' : 'none';
    }
  }

  if (floatingMenuBtn) {
    floatingMenuBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      changeToggle();
      const isOpen = details && details.classList.contains('open');
      updateFloatingMenuIcon(isOpen);
      if (isOpen && floatingWidget && floatingWidget.classList.contains('open')) {
        floatingWidget.classList.remove('open');
        updateFloatingBtnIcon(false);
      }
    });
  }

  if (blockerBlock) {
    blockerBlock.addEventListener('click', () => {
      if (details && details.classList.contains('open')) {
        changeToggle();
      }
      updateFloatingMenuIcon(false);
    });
  }
  if (openClose) {
    openClose.addEventListener('click', () => {
      const isOpen = details && details.classList.contains('open');
      updateFloatingMenuIcon(isOpen);
    });
  }

  // Mobile Floating Tools Widget (Bottom Right)
  const floatingBtn = document.getElementById('FloatingToolsBtn');
  const floatingWidget = document.getElementById('FloatingToolsWidget');
  const floatingOverlay = document.getElementById('FloatingToolsOverlay');

  function updateFloatingBtnIcon(isOpen) {
    const searchIcon = document.getElementById('FloatingToolsBtnSearchIcon');
    const closeIcon = document.getElementById('FloatingToolsBtnCloseIcon');
    if (searchIcon && closeIcon) {
      searchIcon.style.display = isOpen ? 'none' : 'block';
      closeIcon.style.display = isOpen ? 'block' : 'none';
    }
  }

  if (floatingBtn && floatingWidget) {
    floatingBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = floatingWidget.classList.toggle('open');
      updateFloatingBtnIcon(isOpen);
      if (isOpen) {
        if (details && details.classList.contains('open')) {
          changeToggle();
          updateFloatingMenuIcon(false);
        }
        const input = floatingWidget.querySelector('.floating-search-input');
        if (input) setTimeout(() => input.focus(), 200);
      }
    });
  }

  if (floatingOverlay && floatingWidget) {
    floatingOverlay.addEventListener('click', () => {
      floatingWidget.classList.remove('open');
      updateFloatingBtnIcon(false);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      setGlobalSearchOpen(false);
      if (floatingWidget) {
        floatingWidget.classList.remove('open');
        updateFloatingBtnIcon(false);
      }
      if (details && details.classList.contains('open')) {
        changeToggle();
        updateFloatingMenuIcon(false);
      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
